export default {
    props: [
        'name',
        'id',
        'amount',
        'minAmount',
        'image',
        'counted'
    ],

    methods: {
        modalShow() {
            this.$emit('clicked', this.id);
        },
    },
}